import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { AppRoutes } from "../../Constants/AppRoutes";
import { GlobalState } from "../../Redux/RootReducer";
import "./ResetPasswordPage.scss";
import {
  MessageBar,
  MessageBarType,
  PrimaryButton,
  Spinner,
  TextField,
} from "@fluentui/react";
import { useState } from "react";
import ApiService from "../../Services/ApiService";
import { IAPIResponse } from "../../Services/AjaxService";
import { ToastMessage } from "../../Utils/UIMessages";

// uguale al controllo del backend (userService.MIN_PASSWORD_LENGTH)
const MIN_PASSWORD_LENGTH = 8;

const ResetPasswordPage = () => {
  const loggedUser = useSelector((s: GlobalState) => s.generic.user);
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);

  const [password_old, setPassword_old] = useState<string>("");
  const [password_new, setPassword_new] = useState<string>("");
  const [password_new_c, setPassword_new_c] = useState<string>("");

  const changePassword = () => {
    setLoading(true);
    if (loggedUser) {
      ApiService.UsersController.ChangeUserPassword(
        password_old,
        password_new,
        (response: IAPIResponse) => {
          if (response.error === null) {
            ToastMessage("success", "Password modificata con successo.");
            //navigate(AppRoutes.APP_LOGOUT_PAGE);
          } else {
            // il backend dice il motivo: vecchia password sbagliata o nuova troppo corta
            ToastMessage(
              "error",
              "Impossibile cambiare la password. " +
                (response.parsed?.message ?? "La vecchia password non è corretta.")
            );
          }
          setLoading(false);
        }
      );
    }
  };

  return (
    <div className="reset-password-wrap">
      <h2>Resetta la tua password</h2>
      {loading && <Spinner label="Caricamento..." />}
      {!loading && (
        <div>
          <div style={{ width: "fit-content" }}>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                changePassword();
              }}
            >
              <TextField
                label="Vecchia password"
                canRevealPassword
                type="password"
                onChange={(e, t) => {
                  if (t !== undefined) {
                    setPassword_old(t);
                  }
                }}
              />
              <TextField
                label="Nuova password"
                canRevealPassword
                type="password"
                onChange={(e, t) => {
                  if (t !== undefined) {
                    setPassword_new(t);
                  }
                }}
              />
              <TextField
                label="Conferma nuova password"
                canRevealPassword
                type="password"
                onChange={(e, t) => {
                  if (t !== undefined) {
                    setPassword_new_c(t);
                  }
                }}
              />
              <br />
              <PrimaryButton
                type="submit"
                disabled={
                  password_old === password_new ||
                  password_old === "" ||
                  password_new !== password_new_c ||
                  password_new.length < MIN_PASSWORD_LENGTH
                }
              >
                Cambia password
              </PrimaryButton>
            </form>
          </div>
          <div style={{ marginTop: "1em" }}>
            {password_new === password_old && password_old !== "" && (
              <MessageBar messageBarType={MessageBarType.warning}>
                <strong>
                  Attenzione: la vecchia password è uguale alla nuova.
                </strong>
              </MessageBar>
            )}
          </div>
          <div style={{ marginTop: "1em" }}>
            {password_new !== "" && password_new.length < MIN_PASSWORD_LENGTH && (
              <MessageBar messageBarType={MessageBarType.warning}>
                <strong>
                  La nuova password deve avere almeno {MIN_PASSWORD_LENGTH} caratteri.
                </strong>
              </MessageBar>
            )}
          </div>
          <div style={{ marginTop: "1em" }}>
            {password_new_c !== password_new && password_new !== "" && (
              <MessageBar messageBarType={MessageBarType.warning}>
                <strong>
                  Attenzione: nuova password e conferma nuova password non
                  coincidono.
                </strong>
              </MessageBar>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ResetPasswordPage;
